module.exports = __webpack_public_path__ + "static/img/5722_phase_function_Paper_Points.eb9d749.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5722_phase_function_Paper_Points.png
// module id = ykoY
// module chunks = 0